export function isElementVisible(el: Element | null) {
  if (el == null) return false
  return el.getClientRects().length > 0
}
